var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBytedance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2194,
    viewBox: "1.37 0 1198.25 1051.64",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m206.82 943.8-205.45 52.74v-941.44l205.45 53.14z",
    fill: "#325ab4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m532.79 972.14-205.44 53.13v-554.55l205.44 53.13z",
    fill: "#3c8cff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m667.02 388.86 205.84-53.14v554.55l-205.84-53.13z",
    fill: "#00c8d2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1199.62 998.9-205.84 52.74v-1051.64l205.84 53.13z",
    fill: "#78e6dc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBytedance);
export default __webpack_public_path__ + "static/media/bytedance.06a5fe054b65072687c2342795c45a02.svg";
export { ForwardRef as ReactComponent };